"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const ShopCheckoutSummaryMethod = ({ name, media }) => {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-shop-checkout-summary-method', 'd-flex justify-content-between', 'align-items-center') },
        react_1.default.createElement("span", null, name),
        media ? react_1.default.createElement("img", { className: "znd-shop-checkout-radio__image", alt: media.alt, src: media.url }) : null));
};
exports.default = ShopCheckoutSummaryMethod;
